"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("react-toastify/dist/ReactToastify.css");
const react_jss_1 = require("react-jss");
const react_toastify_1 = require("react-toastify");
const react_1 = __importDefault(require("react"));
const theme_1 = __importDefault(require("./theme"));
/**
 * A wrapper for entire app that provides theme context.
 */
const FormThemeProvider = ({ theme = {}, children }) => {
    const [customizedTheme, setCustomizedTheme] = react_1.default.useState(null);
    const [toastContainerProps, setToastContainerProps] = react_1.default.useState({});
    const outerTheme = (0, react_jss_1.useTheme)();
    const isRoot = !outerTheme;
    react_1.default.useEffect(() => {
        const parentTheme = outerTheme || theme_1.default;
        // Use build in react-toastify plugin only if errorNotificationFunc is not defined.
        const usesToastifyPlugin = !(parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.errorNotificationFunc) && !theme.errorNotificationFunc;
        const parsedTheme = Object.assign(Object.assign({ sizes: Object.assign(Object.assign({}, parentTheme.sizes), theme.sizes), colors: Object.assign(Object.assign({}, parentTheme.colors), theme.colors), typography: Object.assign(Object.assign({}, parentTheme.typography), theme.typography), breakpoints: Object.assign(Object.assign({}, parentTheme.breakpoints), theme.breakpoints), textLabels: Object.assign(Object.assign({}, parentTheme.textLabels), theme.textLabels), errorNotificationFunc: (message) => usesToastifyPlugin
                ? react_toastify_1.toast.error(message)
                : parentTheme.errorNotificationFunc
                    ? parentTheme.errorNotificationFunc(message)
                    : theme.errorNotificationFunc
                        ? theme.errorNotificationFunc(message)
                        : () => { } }, usesToastifyPlugin ? { toastContainerProps: Object.assign(Object.assign({}, parentTheme.toastContainerProps), theme.toastContainerProps) } : {}), { customValidationFunction: parentTheme.customValidationFunction || theme.customValidationFunction });
        setCustomizedTheme(parsedTheme);
        if (parsedTheme.toastContainerProps) {
            setToastContainerProps(parsedTheme.toastContainerProps);
        }
    }, []);
    // SSR support - customizedTheme is construted via useEffect hook, which is
    // triggered only on a client, after the render. So for the purpose of
    // Server Side Rendering, if customizedTheme is not set yet, use defautTheme.
    // To prevent ugly initial jump between customized/default look of forms
    // that appears on initial view area of a page (for example in a hero section),
    // set page opacity to 0.
    return (react_1.default.createElement(react_jss_1.ThemeProvider, { theme: customizedTheme || theme_1.default },
        react_1.default.createElement(react_1.default.Fragment, null,
            customizedTheme
                ? children
                : react_1.default.createElement("div", { style: { opacity: 0 } }, children),
            isRoot && toastContainerProps &&
                react_1.default.createElement(react_toastify_1.ToastContainer, Object.assign({}, toastContainerProps)))));
};
exports.default = FormThemeProvider;
